import moment from 'moment';
import EventEmitter from 'node:events';

export class ServiceTime extends EventEmitter {
  startTs = moment().toDate();
  ts = moment().toDate();

  constructor() {
    super();
    setInterval(() => {
      this.ts = moment().toDate();
      this.emit('time');
    }, 1000);
  }

  subscribe(fn: (time: { ts: Date; startTs: Date }) => void) {
    this.on('time', () => fn({ ts: this.ts, startTs: this.startTs }));
  }
}
